import { Component, OnInit, Inject } from '@angular/core';
import { APP_CONFIG } from 'src/app/core/services/app-config.service';
import { AppConfig } from 'src/app/shared/models/config-variable.model';

import { ParkingService} from 'src/app/shared/http-services/parking.service';
import { CarParking } from 'src/app/shared/models/carParking.model';

import {} from 'src/app/shared/utils/utils-global';

@Component({
  selector: 'app-parkings',
  templateUrl: './parkings.component.html',
  styleUrls: ['./parkings.component.scss']
})
export class ParkingsComponent implements OnInit {
	parkings:CarParking[]=[]; // empty array
	currDate:Date =new Date()

	public config: AppConfig = new AppConfig;
  
	constructor(@Inject(APP_CONFIG) config: AppConfig, private parkingService: ParkingService ) { 
		this.config=config;
	}

	getOccupationPercentage(parking:CarParking ) : number {
		return Math.floor( 100 * parking.occupancy / parking.capacity );
	}

	getOccupationClass(parking:CarParking ) : string {
		let percentage:number = this.getOccupationPercentage( parking );
		
		return `p${ Math.floor( percentage/10) }`; 
	}

	ngOnInit(): void {
		this.parkingService.getAll().subscribe(parkings => {
			this.parkings = parkings;
		});
	}
}
